import { registerEvents } from "./skyward.ui.events";
import { loadContent } from "./skyward.ui.window";
import { JQueryInput } from "./types";

const skyward = window.skyward;
//@ts-ignore Remove this once all .js file references are converted to .ts
skyward.ajaxRepeater = skyward.ajaxRepeater || {};

const events =
{
    init
};

registerEvents("ajaxRepeater", events);

//@ts-ignore Remove this once all .js file references are converted to .ts
skyward.ajaxRepeater.load = load;
export function load(placeHolder: JQuery<HTMLElement>)
{
    const data = placeHolder.data();

    if (!data.templateModule || !data.templateController || !data.templateAction || !data.primaryKey)
    {
        return;
    }

    placeHolder.text("Loading...");

    $.when(loadContent(placeHolder.attr("id")!, data.templateModule, data.templateController, data.templateAction, data.primaryKey, data.postdata).done(function ()
    {
        placeHolder.trigger("ajaxRepeaterTemplateLoaded", placeHolder);
    }));
}

function init(element: JQueryInput)
{
    const placeHolder = $(element);
    load(placeHolder);
}